import { createContext, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";
import { IdleTimer } from "@/components/IdleTimer";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = unauth, object = authed

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setUser(false); });
  }, []);

  const setAuth = (token, u) => {
    localStorage.setItem(TOKEN_KEY, token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, setAuth, logout }}>
      {children}
      <IdleTimer />
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
